<script setup lang="ts">
import { analytics } from '@/scitylana';
import {
    claimPageUrl,
    navigateTo,
} from '@/url';

import TruButton from '../TruButton.vue';
import TruCard from '../TruCard.vue';

function gotoClaims() {
    analytics.quickLinks.startClaim();

    navigateTo('/Claims');
}
function gotoPreApproval() {
    analytics.quickLinks.preApproval();

    navigateTo(claimPageUrl(undefined, undefined, true));
}
</script>

<template>
    <div class="quick-links">
        <TruCard :header="$t('dashboard.quickLinks.header')">
            <div class="quick-links-content flex">
                <div class="new-claim-container flex flex-col items-center gap-5">
                    <img
                        class="new-claim-image"
                        src="../../assets/images/start-new-claim.svg"
                        :alt="$t('dashboard.quickLinks.newClaimAltText')"
                    >

                    <TruButton
                        secondary
                        outlined
                        size="xs"
                        @click="gotoClaims"
                    >
                        {{ $t('dashboard.quickLinks.newClaimButton') }}
                    </TruButton>

                    <div class="new-claim-text text-white desk-cap2-reg text-center">
                        {{ $t('dashboard.quickLinks.newClaimText') }}
                    </div>
                </div>

                <div class="vertical-line self-stretch grow" />

                <div class="pre-approval-container flex flex-col items-center gap-5">
                    <img
                        class="pre-approval-image"
                        src="../../assets/images/truck-medical.svg"
                        :alt="$t('dashboard.quickLinks.preApprovalAltText')"
                    >

                    <TruButton
                        secondary
                        outlined
                        size="xs"
                        @click="gotoPreApproval"
                    >
                        {{ $t('dashboard.quickLinks.preApprovalButton') }}
                    </TruButton>

                    <div class="new-claim-text text-white desk-cap2-reg text-center">
                        {{ $t('dashboard.quickLinks.preApprovalText') }}
                    </div>
                </div>
            </div>
        </TruCard>
    </div>
</template>

<style scoped lang="scss">
@use '../../scss/variables' as *;

.dashboard-page .quick-links {
    .new-claim-image {
        width: 7.25rem;
    }

    .pre-approval-image {
        width: 10rem;
    }

    :deep(.tru-button.outlined) {
        background: var(--tru-blue);
        color: var(--tru-white);
    }

    :deep(.tru-button.btn) {
        border-color: var(--tru-white);
    }

    :deep(.tru-card-body) {
        background-color: var(--tru-blue);
    }

    .vertical-line {
        border-left: 1px solid var(--tru-white);
        margin: 0 3rem;
    }

    .new-claim-container,
    .pre-approval-container {
        width: 50%;
    }
}
</style>
